import {
	Accordion,
	ManufacturerIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { type ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../../filter-header.component";
import { useFiltersContext } from "../../filters.context";

interface ProducersFilterProps {
	children?: ReactNode;
}

export function ProducersFilter({ children }: ProducersFilterProps) {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange, onTopProducerWarning } =
		useFiltersContext();
	const value = filters.producers ?? [];

	const onValueChange = useCallback(
		(v: string[]) => {
			if (filters.topProducersLowPrice) {
				onTopProducerWarning?.();
			}
			onFilterChange(
				"producers",
				v.map((val) => Number(val)),
			);
			onFilterChange("topProducersLowPrice", false);
		},
		[filters.topProducersLowPrice, onFilterChange, onTopProducerWarning],
	);

	return (
		<Accordion.Item
			value="producers"
			variant="filter"
			data-testid="producers-filter"
		>
			<Accordion.Trigger
				variant="filter"
				data-testid="producers-filter-trigger"
			>
				<FilterHeader
					title={t("filters.producers")}
					value={Number(value?.length)}
					icon={<ManufacturerIcon size={5} />}
				/>
			</Accordion.Trigger>
			<Accordion.Content className="px-4 pb-4">
				{children}

				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2 pt-3"
					value={value.map((v: number) => v.toString())}
					onValueChange={onValueChange}
				>
					{config.producers.map((producer) => (
						<ToggleGroup.Item key={producer.id} value={producer.id.toString()}>
							{producer.name}
						</ToggleGroup.Item>
					))}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
